module.exports = __webpack_public_path__ + "img/img_uniform_service.290a881f.jpg";